import { useSelector } from 'react-redux';
import { selectActionUrl, selectMasterButton } from '../../../selectors/landing';
import { ContainerInner } from '../../../components/ContainerInner';
import { Button, UIText2 } from '@cian/ui-kit';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAuthorized, useCianAuthorized, useIsMortgageRedirectEnabled } from '../../../hooks/useAuthorized';
import { EFillApplicationStickyButtonType } from './types';
import { ScrollUpButtonContainer } from '../ScrollUpButtonContainer';
import { NBSP } from 'shared/constants/common';
import cn from 'clsx';

import * as styles from './styles.css';

export interface IFillApplicationButtonMobileProps {
  handleOnload: (node: HTMLElement | null) => void;
  show: boolean;
}

export const FillApplicationButtonMobile: React.FC<IFillApplicationButtonMobileProps> = ({ handleOnload, show }) => {
  const enabledButton = useSelector(selectMasterButton);
  const isMortgageRedirectEnabled = useIsMortgageRedirectEnabled();
  const { authorizeAndRedirect } = useAuthorized();
  const { cianAuthorizeAndRedirect } = useCianAuthorized();
  const masterButtonActionUrl = useSelector(selectActionUrl) as string;
  const rootRef = useRef<HTMLDivElement | null>(null);
  const isTopActive = enabledButton === EFillApplicationStickyButtonType.TOP;

  useEffect(() => {
    if (!show) {
      handleOnload(null);

      return;
    }

    handleOnload(rootRef.current);

    return () => handleOnload(null);
  }, [show, handleOnload]);

  const handleClick = useCallback(() => {
    if (isMortgageRedirectEnabled) {
      cianAuthorizeAndRedirect();
    } else {
      authorizeAndRedirect({ path: masterButtonActionUrl, analyticEventKey: EFillApplicationStickyButtonType.TOP });
    }
  }, [masterButtonActionUrl, isMortgageRedirectEnabled, authorizeAndRedirect, cianAuthorizeAndRedirect]);

  if (!show) {
    return null;
  }

  return (
    <div ref={rootRef} suppressHydrationWarning className={cn(styles['mobile-btn'], isTopActive && styles['active'])}>
      <div className={styles['scroll-up']}>
        <ScrollUpButtonContainer />
      </div>
      <ContainerInner>
        <div className={styles['mobile-wrapper']}>
          <Button fullWidth size="M" onClick={handleClick}>
            Заполнить заявку на Циане
          </Button>
          <div>
            <UIText2 textAlign="center" color="text-secondary-default">
              Заявка{NBSP}— единая для всех банков.
            </UIText2>
            <UIText2 textAlign="center" color="text-secondary-default">
              Перед заполнением попросим авторизоваться.
            </UIText2>
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
